import http from "../http-common";


const getCaptcha = () => {
  return http.get("/get-captcha");
};
const CaptchaService = {
    getCaptcha,
}
export default CaptchaService;